import { gkApi } from './index';

const stockApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listStorageStocks: builder.query({
      query: (storageId) => ({
        url: `/stock/${storageId}/`,
        method: 'get',
        params: { limit: 500 },
      }),
      providesTags: ['STOCK'],
    }),
    listStocks: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/stock/`,
        method: 'get',
        params: { limit: 500 },
      }),
      providesTags: ['STOCK'],
    }),
    // Full (unpaginated) event-scoped movement log for the audit screen; the
    // 'STOCK' tag means goods-receipt/correction/transfer mutations refresh it.
    listStockMovements: builder.query({
      query: ({ eventId }) => ({
        url: `/event/${eventId}/stock-movement/`,
        method: 'get',
      }),
      providesTags: ['STOCK'],
    }),
    postGoodsReceipt: builder.mutation({
      query: (payload) => ({
        url: '/stock-movement/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: ['STOCK'],
    }),
    postStockCorrection: builder.mutation({
      query: (payload) => ({
        url: '/stock-correction/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: ['STOCK'],
    }),
    postStockTransfer: builder.mutation({
      query: (payload) => ({
        url: '/stock-transfer/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: ['STOCK'],
    }),
  }),
});

export const {
  useListStorageStocksQuery,
  useListStocksQuery,
  useListStockMovementsQuery,
  usePostGoodsReceiptMutation,
  usePostStockCorrectionMutation,
  usePostStockTransferMutation,
} = stockApi;
